module.exports = __webpack_public_path__ + "img/new_5.11dd8703.jpeg";